import React, { EventHandler } from 'react'

export interface PillProps {
    text: string;
    onClick?: EventHandler<any>;
    showCross?: boolean;
}

const Pill = (props: PillProps) => {
  return (
    <>
        {!!props.text && <div className="rounded-[0.625rem] border border-[#890526] p-[0.625rem] text-[#890526] flex flex-row gap-3 cursor-pointer" onClick={props.onClick}>
            {props.text} {props.showCross && <img src='/cross.svg'/>}
        </div>}
    </>
  )
}

export default Pill